import { Link } from "react-router-dom";
import { ScrollText, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const SECTIONS = [
    {
        n: "1",
        title: "Premesse",
        body: (
            <>
                <p>Benvenuto su <strong>CondominioNow – L'esperto risponde</strong>.</p>
                <p className="mt-3">L'accesso e l'utilizzo della piattaforma implicano la piena accettazione dei presenti Termini e Condizioni.</p>
                <p className="mt-3">CondominioNow è una piattaforma informativa gratuita sviluppata e gestita da <strong>Nowgestioni S.r.l.</strong> con finalità divulgative, informative e orientative in materia condominiale.</p>
                <p className="mt-3">L'utente è tenuto a leggere attentamente i presenti Termini prima di utilizzare il servizio.</p>
            </>
        ),
    },
    {
        n: "2",
        title: "Oggetto del servizio",
        body: (
            <>
                <p>CondominioNow offre contenuti informativi relativi al mondo del condominio, tra cui:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>guide pratiche;</li>
                    <li>approfondimenti;</li>
                    <li>domande e risposte veloci;</li>
                    <li>contenuti divulgativi;</li>
                    <li>richieste informative inviate dagli utenti;</li>
                    <li>risposte fornite attraverso la piattaforma.</li>
                </ul>
                <p className="mt-3">Il servizio è attualmente fornito a titolo gratuito.</p>
                <p className="mt-3">Nowgestioni S.r.l. si riserva il diritto di modificare, sospendere o interrompere in qualsiasi momento il servizio o singole funzionalità senza obbligo di preavviso.</p>
            </>
        ),
    },
    {
        n: "3",
        title: "Natura esclusivamente informativa del servizio",
        body: (
            <>
                <p>CondominioNow ha esclusivamente finalità informative, divulgative e orientative.</p>
                <p className="mt-3">Tutti i contenuti presenti sulla piattaforma, comprese le risposte fornite agli utenti, sono pubblicati esclusivamente per finalità informative.</p>
                <p className="mt-3 font-semibold text-slate-900">Le informazioni presenti sul sito NON costituiscono:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>consulenza legale;</li>
                    <li>consulenza tecnica;</li>
                    <li>consulenza fiscale;</li>
                    <li>consulenza professionale personalizzata;</li>
                    <li>parere professionale;</li>
                    <li>perizia;</li>
                    <li>attività professionale riservata;</li>
                    <li>incarico professionale.</li>
                </ul>
                <p className="mt-3">Le informazioni pubblicate non sostituiscono la valutazione specifica di un professionista incaricato direttamente dall'utente e non possono tenere conto di tutte le circostanze concrete, della documentazione completa o delle particolarità del singolo caso.</p>
                <p className="mt-3">Prima di assumere decisioni, intraprendere azioni o omettere comportamenti che possano produrre effetti giuridici, economici, amministrativi o patrimoniali, l'utente è tenuto a rivolgersi a professionisti abilitati per una valutazione specifica della propria situazione.</p>
            </>
        ),
    },
    {
        n: "4",
        title: "Assenza di rapporto professionale",
        body: (
            <>
                <p>L'utilizzo della piattaforma non determina la nascita di alcun rapporto professionale, fiduciario, consulenziale o contrattuale tra l'utente e:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>Nowgestioni S.r.l.;</li>
                    <li>il Dott. Luigi Colaianni;</li>
                    <li>collaboratori;</li>
                    <li>dipendenti;</li>
                    <li>professionisti eventualmente coinvolti nel progetto.</li>
                </ul>
                <p className="mt-3">L'utilizzo della piattaforma non costituisce conferimento di incarico professionale.</p>
            </>
        ),
    },
    {
        n: "5",
        title: "Registrazione e account",
        body: (
            <>
                <p>Per accedere ad alcune funzionalità è richiesta la registrazione.</p>
                <p className="mt-3">L'utente si impegna a:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>fornire dati veritieri e aggiornati;</li>
                    <li>custodire con cura le proprie credenziali;</li>
                    <li>non condividere il proprio account con terzi;</li>
                    <li>utilizzare la piattaforma nel rispetto della normativa vigente.</li>
                </ul>
                <p className="mt-3">L'utente è responsabile di ogni attività svolta tramite il proprio account.</p>
            </>
        ),
    },
    {
        n: "6",
        title: "Utilizzo corretto della piattaforma",
        body: (
            <>
                <p className="font-semibold text-slate-900">È vietato:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>utilizzare la piattaforma per finalità illecite;</li>
                    <li>inserire contenuti offensivi, diffamatori o discriminatori;</li>
                    <li>pubblicare dati personali di terzi senza autorizzazione;</li>
                    <li>violare diritti di proprietà intellettuale;</li>
                    <li>compromettere la sicurezza del sistema;</li>
                    <li>utilizzare il servizio in modo improprio o fraudolento.</li>
                </ul>
            </>
        ),
    },
    {
        n: "7",
        title: "Responsabilità dei contenuti inseriti dall'utente",
        body: (
            <>
                <p>L'utente è l'unico responsabile dei dati, documenti, allegati e informazioni caricati sulla piattaforma.</p>
                <p className="mt-3">L'utente garantisce di avere il diritto di utilizzare e trasmettere tali contenuti.</p>
                <p className="mt-3">Nowgestioni S.r.l. non effettua verifiche preventive sulla veridicità, correttezza o completezza delle informazioni inserite dagli utenti.</p>
            </>
        ),
    },
    {
        n: "8",
        title: "Manleva",
        body: (
            <>
                <p>L'utente si impegna a manlevare e tenere indenne Nowgestioni S.r.l., il Dott. Luigi Colaianni, amministratori, dipendenti, collaboratori e professionisti coinvolti nel progetto da qualsiasi contestazione, richiesta, danno, pretesa risarcitoria, costo, spesa legale, procedimento amministrativo o giudiziario derivante:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>dall'utilizzo della piattaforma;</li>
                    <li>dalla violazione dei presenti Termini;</li>
                    <li>dai contenuti caricati;</li>
                    <li>dalla violazione di diritti di terzi.</li>
                </ul>
            </>
        ),
    },
    {
        n: "9",
        title: "Limitazione di responsabilità",
        body: (
            <>
                <p>L'utilizzo della piattaforma avviene sotto l'esclusiva responsabilità dell'utente.</p>
                <p className="mt-3">Nowgestioni S.r.l., il Dott. Luigi Colaianni e tutti i soggetti coinvolti nella gestione della piattaforma non potranno essere ritenuti responsabili, a qualsiasi titolo, per:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>errori od omissioni presenti nei contenuti;</li>
                    <li>interpretazioni errate delle informazioni;</li>
                    <li>decisioni adottate dagli utenti;</li>
                    <li>danni diretti o indiretti;</li>
                    <li>perdite economiche;</li>
                    <li>mancati guadagni;</li>
                    <li>danni patrimoniali o non patrimoniali;</li>
                    <li>responsabilità verso terzi.</li>
                </ul>
                <p className="mt-3">L'utente riconosce espressamente che nessuna risposta pubblicata sulla piattaforma costituisce garanzia di risultato o parere professionale vincolante.</p>
            </>
        ),
    },
    {
        n: "10",
        title: "Assenza di garanzie",
        body: (
            <>
                <p>Nowgestioni S.r.l. non garantisce che:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>il servizio sia sempre disponibile;</li>
                    <li>il servizio sia privo di errori;</li>
                    <li>ogni richiesta riceva risposta;</li>
                    <li>le informazioni siano complete, corrette o aggiornate;</li>
                    <li>il servizio soddisfi particolari aspettative dell'utente.</li>
                </ul>
                <p className="mt-3">La piattaforma viene fornita nello stato di fatto e di diritto in cui si trova.</p>
            </>
        ),
    },
    {
        n: "11",
        title: "Sospensione o chiusura dell'account",
        body: (
            <p>Nowgestioni S.r.l. si riserva il diritto di sospendere, limitare o disattivare qualsiasi account, senza obbligo di preavviso, qualora ritenga che l'utilizzo della piattaforma sia improprio, illecito o potenzialmente dannoso.</p>
        ),
    },
    {
        n: "12",
        title: "Proprietà intellettuale",
        body: (
            <>
                <p>Il marchio CondominioNow, il logo, la grafica, le guide pratiche, le risposte, i testi, le banche dati e ogni altro contenuto presente sulla piattaforma sono di proprietà esclusiva di Nowgestioni S.r.l. o dei rispettivi titolari.</p>
                <p className="mt-3">È vietata qualsiasi riproduzione, distribuzione o utilizzo senza autorizzazione scritta.</p>
            </>
        ),
    },
    {
        n: "13",
        title: "Modifiche del servizio",
        body: (
            <>
                <p>Nowgestioni S.r.l. può modificare, aggiornare, limitare, sospendere o interrompere il servizio in qualsiasi momento.</p>
                <p className="mt-3">L'utente rinuncia a qualsiasi richiesta di indennizzo o risarcimento derivante da tali modifiche.</p>
            </>
        ),
    },
    {
        n: "14",
        title: "Modifiche ai presenti Termini",
        body: (
            <>
                <p>Nowgestioni S.r.l. si riserva il diritto di modificare i presenti Termini e Condizioni in qualsiasi momento.</p>
                <p className="mt-3">Le nuove versioni saranno pubblicate sulla piattaforma e diventeranno efficaci dalla data di pubblicazione.</p>
            </>
        ),
    },
    {
        n: "15",
        title: "Legge applicabile e foro competente",
        body: (
            <>
                <p>I presenti Termini e Condizioni sono regolati dalla <strong>legge italiana</strong>.</p>
                <p className="mt-3">Per ogni controversia sarà competente il Foro previsto dalla normativa applicabile.</p>
                <p className="mt-3">Restano impregiudicati gli eventuali diritti inderogabili riconosciuti ai consumatori dalla legge.</p>
            </>
        ),
    },
    {
        n: "16",
        title: "Contatti",
        body: (
            <p>
                <strong>CondominioNow – L'esperto risponde</strong>
                <br />
                Un servizio di Nowgestioni S.r.l.
                <br />
                Email: <a href="mailto:info@nowgestioni.it" className="text-primary hover:underline">info@nowgestioni.it</a>
            </p>
        ),
    },
    {
        n: "17",
        title: "Missione del progetto",
        body: (
            <>
                <p>CondominioNow nasce per rendere le informazioni condominiali più accessibili, comprensibili e utili per tutti.</p>
                <p className="mt-3">Crediamo che una persona correttamente informata possa affrontare con maggiore serenità le sfide della vita condominiale.</p>
                <p className="mt-3">Per questo mettiamo gratuitamente la nostra esperienza al servizio della comunità.</p>
            </>
        ),
    },
];

export default function Terms() {
    return (
        <div className="bg-white">
            {/* HERO */}
            <section className="relative overflow-hidden border-b border-slate-200">
                <div
                    aria-hidden
                    className="absolute inset-0 bg-[radial-gradient(1000px_400px_at_-10%_-20%,rgba(15,76,129,0.08),transparent_60%)]"
                />
                <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
                    <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 border border-primary/20 px-3 py-1.5 text-xs font-semibold uppercase tracking-widest text-primary" data-testid="terms-badge">
                        <ScrollText className="size-3.5" /> Documento contrattuale
                    </div>
                    <h1
                        data-testid="terms-title"
                        className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold leading-tight tracking-tight text-slate-900"
                    >
                        Termini e condizioni di utilizzo
                    </h1>
                    <p className="mt-4 text-lg text-slate-600 max-w-2xl leading-relaxed">
                        L'accesso e l'utilizzo della piattaforma <strong>CondominioNow</strong> implicano la piena accettazione dei presenti Termini e Condizioni.
                    </p>
                    <p className="mt-2 text-sm text-muted-foreground" data-testid="terms-updated">
                        Ultimo aggiornamento: <strong>Agosto 2026</strong>
                    </p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
                <div className="grid gap-6 lg:grid-cols-[260px_1fr]">
                    {/* Sticky index */}
                    <aside className="hidden lg:block">
                        <div className="sticky top-24">
                            <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-3">Indice</div>
                            <ol className="space-y-1.5 text-sm">
                                {SECTIONS.map(s => (
                                    <li key={s.n}>
                                        <a href={`#sez-${s.n}`} className="flex items-start gap-2 text-slate-600 hover:text-primary transition py-0.5">
                                            <span className="text-slate-400 font-mono text-xs w-5 shrink-0">{s.n}.</span>
                                            <span className="leading-snug">{s.title}</span>
                                        </a>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </aside>

                    {/* Sections */}
                    <article className="min-w-0" data-testid="terms-content">
                        <div className="space-y-8">
                            {SECTIONS.map(s => (
                                <section
                                    key={s.n}
                                    id={`sez-${s.n}`}
                                    className="scroll-mt-24 rounded-2xl border border-slate-200 bg-white p-6 lg:p-8 shadow-[0_1px_2px_0_rgba(0,0,0,0.04)]"
                                    data-testid={`terms-section-${s.n}`}
                                >
                                    <div className="flex items-start gap-4">
                                        <div className="shrink-0 size-10 rounded-xl bg-primary/10 flex items-center justify-center">
                                            <span className="font-serif text-lg font-semibold text-primary">{s.n}</span>
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <h2 className="font-serif text-2xl font-semibold text-slate-900 leading-tight">{s.title}</h2>
                                            <div className="mt-3 text-slate-700 leading-relaxed text-[15px]">{s.body}</div>
                                        </div>
                                    </div>
                                </section>
                            ))}
                        </div>

                        {/* Contact CTA */}
                        <div className="mt-10 rounded-2xl bg-slate-950 text-white p-8 lg:p-10" data-testid="terms-contact-cta">
                            <div className="flex items-start gap-4 flex-wrap">
                                <div className="size-12 rounded-xl bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
                                    <Mail className="size-5 text-amber-400" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <h3 className="font-serif text-2xl font-semibold">Domande sui Termini?</h3>
                                    <p className="mt-2 text-slate-300 text-sm">
                                        Scrivici a <a href="mailto:info@nowgestioni.it" className="text-amber-300 underline underline-offset-4 hover:text-amber-200">info@nowgestioni.it</a> — leggi anche la nostra <Link to="/privacy" className="text-amber-300 underline underline-offset-4 hover:text-amber-200">Privacy Policy</Link>.
                                    </p>
                                </div>
                                <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold rounded-full">
                                    <Link to="/come-funziona">Scopri come funziona <ArrowRight className="size-4 ml-1" /></Link>
                                </Button>
                            </div>
                        </div>
                    </article>
                </div>
            </section>
        </div>
    );
}
